export default "__VITE_ASSET__9ed9229b__"